<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoCrud
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <Cuit
                    :model="itemActivo.Nombre"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Nombre = item.Cuit)"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Clave*"
                    v-model="itemActivo.Clave"
                    :rules="[rules.requerido, rules.minimo4, rules.maximo50]"
                    :readonly="accesoRestringido"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                    hint="Al menos 4 caracteres"
                    counter
                    @click:append="mostrarClave()"
                    @keyup.enter="ejecutarAccion('Login')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Teléfono"
                    v-model="itemActivo.Telefono"
                    hint="Prefijo (con 0) y número"
                    persistent-hint
                    :rules="[rules.maximo50]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="E-mail"
                    v-model="itemActivo.Email"
                    :rules="[rules.maximo50, rules.email]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <p>Tipo*</p>
                  <v-radio-group v-model="iTipoEmpleado" :mandatory="false">
                    <v-radio label="Empleado" value="Empleado"></v-radio>
                    <v-radio label="Comercio" value="Empresa"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md6>
                  <v-flex>
                    <p>Estado*</p>
                    <v-btn-toggle v-model="iEstado">
                      <v-btn>Creado</v-btn>
                      <v-btn>Confirmado</v-btn>
                    </v-btn-toggle>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <GrillaCrud
      :activo="grillaActivo"
      :columnas="grillaColumnas"
      :itemsDB="grillaItems"
      :loading="loading"
      @ejecutarAccion="grillaEjecutarAccion"
      @editarItem="grillaEditarItem"
      @borrarItem="grillaBorrarItem"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoCrud from "@/components/EncabezadoCrud";
import PieCrud from "@/components/PieCrud";
import GrillaCrud from "@/components/GrillaCrud";
import Mensaje from "@/components/Mensaje";
import Cuit from "@/components/Cuit";
export default {
  name: "UsuarioCrud",
  components: {
    EncabezadoCrud,
    PieCrud,
    GrillaCrud,
    Mensaje,
    Cuit
  },
  data() {
    return {
      titulo: "Usuarios",
      rutaApi: "Usuario/",
      itemVacio: {
        Id_Usuario: 0,
        Nombre: "",
        Email: "",
        Telefono: "",
        Clave: "",
        Salt: "",
        Estado: "",
        TipoEmpleado: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido",
        minimo4: v => (!!v && v.length >= 4) || "Mínimo 4 caracteres",
        maximo50: v => (v || "").length <= 50 || "Máximo 50 caracteres",
        email: v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return !v || pattern.test(v) || "E-mail no válido";
        }
      },
      grillaColumnas: [
        { text: "Usuario", value: "Nombre" },
        { text: "Teléfono", value: "Telefono" },
        { text: "Email", value: "Email" }
      ],
      grillaItems: [],
      grillaActivo: false,
      loading: false,
      show1: false,
      accesoRestringido: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: ""
    };
  },
  computed: {
    iTipoEmpleado: {
      get: function() {
        return this.itemActivo.TipoEmpleado ? "Empleado" : "Empresa";
      },
      set: function(valor) {
        this.itemActivo.TipoEmpleado = valor == "Empleado";
      }
    },
    iEstado: {
      get: function() {
        return parseInt(this.itemActivo.Estado) - 1;
      },
      set: function(valor) {
        this.itemActivo.Estado = (valor + 1).toString();
      }
    }
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Nuevo":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoCuit");
          break;
        case "Guardar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "Abrir":
          this.grillaActivo = true;
          this.grillaItems = [];
          break;
        case "Editar":
          this.grillaActivo = false;
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoCuit");
          this.validarAccesoRestringido();
          break;
        case "Borrar":
          this.grillaActivo = false;
          this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          break;
        case "AceptarConfirmacionBorrar":
          this.borrarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarConfirmacionBorrar":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = true;
          this.$refs.form.resetValidation();
          break;
      }
    },
    validarAccesoRestringido() {
      this.accesoRestringido =
        this.itemActivo.TipoEmpleado &&
        this.itemActivo.Nombre != this.$store.state.nombreUsuario;
    },
    mostrarClave() {
      if (!this.accesoRestringido) this.show1 = !this.show1;
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post(this.rutaApi, item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarItem(item) {
      this.loading = true;
      HttpHelper.delete(this.rutaApi + item.Id_Usuario)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEjecutarAccion(accion, textoBuscado) {
      switch (accion) {
        case "Listar":
          this.grillaListarItems(textoBuscado);
          break;
        case "Cerrar":
          this.grillaActivo = false;
          break;
      }
    },
    grillaListarItems(textoBuscado) {
      this.loading = true;
      this.grillaItems = [];
      HttpHelper.get(this.rutaApi, {
        palabra: textoBuscado
      })
        .then(response => {
          this.grillaItems = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEditarItem(item) {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        id: item.Id_Usuario
      })
        .then(response => {
          this.itemActivo = Object.assign({}, response.data);
          this.ejecutarAccion("Editar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaBorrarItem(item) {
      this.itemActivo = item;
      this.ejecutarAccion("Borrar");
    },
    mostrarError(error) {
      let detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
